import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const filters = [
  { label: "Receptions", filter: ".col-one" },
  { label: "Weddings", filter: ".col-two" },
  { label: "Home Decor", filter: ".col-three" },
  { label: "Pre-Wedding", filter: ".col-four" },
  { label: "Rentals", filter: ".col-five" },
];

const projects = [
  {
    image: require("./../../images/featured/image-1.JPG"),
    mobileImage: require("./../../images/featured/image-1.JPG"),
    title: "Receptions",
    address: "Sed ut perspiciatis unde",
    filter: "col-one",
    id: "Receptions",
  },
  {
    image: require("./../../images/featured/image-2.JPG"),
    mobileImage: require("./../../images/featured/image-2-mob.PNG"),
    title: "Weddings",
    address: "Sed ut perspiciatis unde",
    filter: "col-two",
    id: "Weddings",
  },
  {
    image: require("./../../images/featured/image-3.JPG"),
    mobileImage: require("./../../images/featured/image-3.JPG"),
    title: "Home Decor",
    address: "Sed ut perspiciatis unde",
    filter: "col-three",
    id: "Home-Decor",
  },
  {
    image: require("./../../images/featured/image-13.PNG"),
    mobileImage: require("./../../images/featured/image-13.PNG"),
    title: "Pre-Wedding",
    address: "Sed ut perspiciatis unde",
    filter: "col-four",
    id: "Pre-Wedding",
  },
  {
    image: require("./../../images/featured/image-5.JPG"),
    mobileImage: require("./../../images/featured/image-5.JPG"),
    title: "Home Decor",
    address: "Sed ut perspiciatis unde",
    filter: "col-three",
    id: "Home-Decor",
  },
  {
    image: require("./../../images/featured/image-6.JPG"),
    mobileImage: require("./../../images/featured/image-6-mob.PNG"),
    title: "Weddings",
    address: "Sed ut perspiciatis unde",
    id: "Weddings",
    filter: "col-two",
  },
  {
    image: require("./../../images/featured/image-7.PNG"),
    mobileImage: require("./../../images/featured/image-7-mob.PNG"),
    title: "Receptions",
    address: "Sed ut perspiciatis unde",
    id: "Receptions",
    filter: "col-one",
  },
  {
    image: require("./../../images/featured/image-8.PNG"),
    mobileImage: require("./../../images/featured/image-8.PNG"),
    title: "Rentals",
    address: "Sed ut perspiciatis unde",
    id: "Rentals",
    filter: "col-five",
  },
  {
    image: require("./../../images/featured/image-9.JPG"),
    mobileImage: require("./../../images/featured/image-9.JPG"),
    title: "Home Decor",
    address: "Sed ut perspiciatis unde",
    filter: "col-three",
    id: "Home-Decor",
  },
  {
    image: require("./../../images/featured/image-11.PNG"),
    mobileImage: require("./../../images/featured/image-11-mob.PNG"),
    title: "Weddings",
    address: "Sed ut perspiciatis unde",
    id: "Weddings",
    filter: "col-two",
  },
  {
    image: require("./../../images/featured/image-12.JPG"),
    mobileImage: require("./../../images/featured/image-12-mob.PNG"),
    title: "Receptions",
    address: "Sed ut perspiciatis unde",
    id: "Receptions",
    filter: "col-one",
  },
];

var bgimg1 = require("./../../images/background/bg-image.png");

const Projects1 = () => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);

  // Update isMobileView state on window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.addEventListener("load", () => {
          resolve();
        });
        script.addEventListener("error", (e) => {
          reject(e);
        });
        document.body.appendChild(script);
        document.body.removeChild(script);
      });
    };

    loadScript("./assets/js/custom.js");
  }, []);

  const options = {
    loop: false,
    autoplay: false,
    margin: 30,
    nav: true,
    dots: false,
    navText: ["Prev", "Next"],
    responsive: {
      0: {
        items: 1,
      },
      540: {
        items: 2,
      },
      768: {
        items: 3,
      },
      991: {
        items: 3,
      },
      1136: {
        items: 4,
      },
      1366: {
        items: 4,
      },
    },
  };
  return (
    <div
      className="section-full mobile-page-padding  p-t80 p-b50 bg-cream"
      style={{ backgroundImage: "url(" + bgimg1 + ")" }}
    >
      <div className="section-content">
        <div className="container">
          {/* TITLE START */}
          <div className="section-head">
            <div className="sx-separator-outer separator-center">
              <div
                className="sx-separator bg-moving bg-repeat-x"
                style={{ backgroundColor: "#22333B" }}
              >
                <h3 className="sep-line-one">Featured Work </h3>
              </div>
            </div>
          </div>
          {/* TITLE END */}
        </div>
        <div className=" filter-carousal-1-outer relative z-index1">
          <div className="container">
            {/* TITLE START */}
            <div className="text-center clearfix filter-pos-right shadow m-b30">
              <ul className="btn-filter-wrap">
                <h4 className="mb-0">
                  Discover Our Stunning Creations on Instagram:{" "}
                  <a href="https://www.instagram.com" target="_blank">
                    @sunlightcreationz{" "}
                  </a>{" "}
                </h4>
                {/* <li className="btn-filter btn-active" data-filter="*">All</li>
                                        {filters.map((item, index) => (
                                            <li key={index} className="btn-filter" data-filter={item.filter}>{item.label}</li>
                                        ))} */}
              </ul>
            </div>
          </div>
          {/* TITLE END */}
          <div className="filter-carousal-1  container-fluid p-b30">
            {/* IMAGE CAROUSEL START */}
            <div className="section-content ">
              <OwlCarousel
                className="owl-carousel owl-carousel-filter owl-btn-bottom-center mfp-gallery navigation-with-name"
                {...options}
              >
                {projects.map((item, index) => (
                  <div
                    key={index + item.id}
                    className={`${item.filter} item fadingcol overflow-hide`}
                  >
                    <div className="sx-box project-height">
                      <div className="sx-thum-bx project-img">
                        <img src={item.image} alt={item.title} />
                      </div>
                      <a className="mfp-link" href={item.image}>
                        <i className="fa fa-arrows-alt" />
                      </a>
                    </div>
                  </div>
                ))}
              </OwlCarousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects1;
